import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation GenerateTemplateDescription($customerId: ID!, $exampleHtml: String!) {
    generateTemplateDescription(customerId: $customerId, exampleHtml: $exampleHtml) {
      description
    }
  }
`;

export const generateTemplateDescription = async ({ customerId, exampleHtml }) => {
  const variables = {
    customerId,
    exampleHtml,
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
